import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const leftNavFn = /* @__PURE__ */ createRecipe('leftNav', {}, [])

const leftNavVariantMap = {}

const leftNavVariantKeys = Object.keys(leftNavVariantMap)

export const leftNav = /* @__PURE__ */ Object.assign(memo(leftNavFn.recipeFn), {
  __recipe__: true,
  __name__: 'leftNav',
  __getCompoundVariantCss__: leftNavFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: leftNavVariantKeys,
  variantMap: leftNavVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, leftNavVariantKeys)
  },
  getVariantProps: leftNavFn.getVariantProps,
})